// a little function to help us with reordering the result
export const reorder = (list: any[], startIndex: number, endIndex: number) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

/**
 * Moves an item from one list to another list.
 */
export const move = (
  source: any[],
  destination: any[],
  sourceIndex: number,
  droppableIndex: number,
) => {
  const sourceClone = Array.from(source)
  const destClone = Array.from(destination)
  const [removed] = sourceClone.splice(sourceIndex, 1)

  destClone.splice(droppableIndex, 0, removed)

  const result = [sourceClone, destClone]

  return result
}
